export default __webpack_public_path__ + "static/media/rudde.9f6e3c71.gif";